
import { mapState } from 'vuex'

export default {
  props: [],
  data() {
    return {
      isCSLoading: false,
    }
  },
  mounted() {   
    
  },
  computed: {
    ...mapState("app", ["cesuan_loading"]),
  },
  methods: {
    autoCalculate() {
      // 保存项目
      // 获取测算数据
      // 导出测算结果
      this.$store.commit('app/SET_CESUAN_LOADING', true)
      this.$parent.doExportingCalculate()     
    },
    async manualCalculate() {
        this.$layer.close(window.lacusuanBtn)
        this.$parent.doManualCalculate()
    }
  }
}
